import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SdHeadingComponent } from '@sdvor/seo/ui';
import { PromocodeGeneratorComponent, PromocodeListComponent } from '../../components';

@Component({
  selector: 'sd-promocodes-page',
  imports: [SdHeadingComponent, PromocodeGeneratorComponent, PromocodeListComponent],
  templateUrl: './promocodes-page.component.html',
  styleUrl: './promocodes-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromocodesPageComponent {}
